import { render, staticRenderFns } from "./GroupRoomoreForcast.vue?vue&type=template&id=5e78aeba&scoped=true&"
import script from "./GroupRoomoreForcast.vue?vue&type=script&lang=js&"
export * from "./GroupRoomoreForcast.vue?vue&type=script&lang=js&"
import style0 from "./GroupRoomoreForcast.vue?vue&type=style&index=0&id=5e78aeba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78aeba",
  null
  
)

export default component.exports